export default "__VITE_ASSET__BEnG98_r__"